<template>
    <div :class="[$options.name, { '-visible': this.isPreloading }]">
        <div class="brand">
            <brand-logo ref="logo" color="#F7A786" />
        </div>
        
    </div>
</template>
<script>
import { gsap } from 'gsap'
import { mapGetters } from 'vuex'
import BrandLogo from '@/components/BrandLogo'

export default {
    name: 'preloader',
    computed: {
        ...mapGetters(['isPreloading'])
    },
    components: {
        'brand-logo': BrandLogo
    },
    mounted() {
        let outline = this.$refs.logo.$el.getElementById('outline')
        outline.classList.add('animate')
    }
}
</script>
<style lang="scss" scoped>
.preloader {
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    left: -9999px;
    position: fixed;
    z-index: 999999999;
    background-color: $white;
    transition: opacity 0.55s ease-out, left 0s 0.55s;
    &.-visible {
        left: 0;
        opacity: 1;
        transition: opacity 0s ease-out, left 0s;
    }
    .brand {
        top: 50%;
        left: 50%;
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
        .cursive {
            font-style: italic;
            color: #F7A786;
        }
    }
}
</style>